import Vue from "vue";
import Vuex from "vuex";
import KrAuth from "./components/auth/auth.js";
//process.env.MIX_APP_ENV
var app_id = `intedashboard.try.${process.env.VUE_APP_ENV}.client`;
Vue.use(Vuex);
// root state object.
// each Vuex instance is just a single state tree.
//alert(localStorage.getItem('jwttoken'),false);
const state = {
  client: {
    profile: {},
    auth: {},
    options: {}, //login options will also now be saved
    socket: {
      isConnected: false,
      isAuthenticated: false,
    },
    impersonate: {
      profile: {},
      auth: {},
      impersonate: false,
    },
    search_history: {},
    courses: [],
    tabs: [], //list of uuids
  },
  session: {
    uuid: "",
  },
};
// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {
  options(state, data) {
    state.client.options = data;
    localStorage.setItem(app_id, JSON.stringify(state.client));
  },
  profile(state, data) {
    state.client.profile = data;
    localStorage.setItem(app_id, JSON.stringify(state.client));
  },
  status(state, data) {
    state.client.profile.status = data;
    localStorage.setItem(app_id, JSON.stringify(state.client));
  },
  canViewQuestionBank(state, data) {
    state.client.profile.canViewQuestionBank = data;
    localStorage.setItem(app_id, JSON.stringify(state.client));
  },
  auth(state, data) {
    state.client.auth = data;
    localStorage.setItem(app_id, JSON.stringify(state.client));
  },
  impersonate_profile(state, data) {
    state.client.impersonate.profile = data;
    localStorage.setItem(app_id, JSON.stringify(state.client));
  },
  impersonate_auth(state, data) {
    state.client.impersonate.auth = data;
    localStorage.setItem(app_id, JSON.stringify(state.client));
  },
  impersonate_status(state, data) {
    state.client.impersonate.impersonate = data;
    localStorage.setItem(app_id, JSON.stringify(state.client));
  },
  socket(state, data) {
    state.client.socket = data;
    localStorage.setItem(app_id, JSON.stringify(state.client));
  },
  SOCKET_connect(state) {
    state.client.socket.isConnected = true;
    localStorage.setItem(app_id, JSON.stringify(state.client));
  },
  SOCKET_access_approved(state) {
    state.client.socket.isAuthenticated = true;
    localStorage.setItem(app_id, JSON.stringify(state.client));
  },
  SOCKET_disconnect(state) {
    state.client.socket.isConnected = false;
    state.client.socket.isAuthenticated = false;
    localStorage.setItem(app_id, JSON.stringify(state.client));
  },
  search_history(state, data) {
    state.client.search_history = data;
    localStorage.setItem(app_id, JSON.stringify(state.client));
  },
  add_search_history(state, data = {}) {
    if (!data.id) {
      //no way to retrieve as we don't do key increments
      return;
    }
    let id = data.id;
    delete data.id;
    state.client.search_history[id] = _.clone(data);
    localStorage.setItem(app_id, JSON.stringify(state.client));
  },

  add_hidden_module(state, data = {}) {
    if (!data.courseUuid || !data.sectionUuid || !data.moduleUuid) {
      //no way to retrieve as we don't do key increments
      return;
    } else {
      let idx = _.findIndex(state.client.courses, function(o) {
        return o.uuid == data.courseUuid;
      });
      if (idx != -1) {
        let idx2 = _.findIndex(state.client.courses[idx].sections, function(o) {
          return o.uuid == data.sectionUuid;
        });
        if (idx2 == -1) {
          state.client.courses[idx].sections.push({
            uuid: data.sectionUuid,
            hidden_modules: [data.moduleUuid],
          });
        } else {
          let section = state.client.courses[idx].sections[idx2];
          let idx3 = section.hidden_modules.indexOf(data.moduleUuid);
          if (idx3 == -1) {
            state.client.courses[idx].sections[idx2].hidden_modules.push(
              data.moduleUuid
            );
          }
        }
      } else {
        state.client.courses.push({
          uuid: data.courseUuid,
          sections: [
            { uuid: data.sectionUuid, hidden_modules: [data.moduleUuid] },
          ],
        });
      }
      localStorage.setItem(app_id, JSON.stringify(state.client));
    }
  },
  remove_hidden_module(state, data = {}) {
    if (!data.courseUuid || !data.sectionUuid || !data.moduleUuid) {
      //no way to retrieve as we don't do key increments
      return;
    } else {
      let idx = _.findIndex(state.client.courses, function(o) {
        return o.uuid == data.courseUuid;
      });
      if (idx != -1) {
        let idx2 = _.findIndex(state.client.courses[idx].sections, function(o) {
          return o.uuid == data.sectionUuid;
        });
        if (idx2 != -1) {
          let section = state.client.courses[idx].sections[idx2];
          let idx3 = section.hidden_modules.indexOf(data.moduleUuid);
          if (idx3 != -1) {
            section.hidden_modules.splice(idx3, 1);
          }
        }
      }
      localStorage.setItem(app_id, JSON.stringify(state.client));
    }
  },
  set_current_section(state, data = {}) {
    if (!data.courseUuid || !data.sectionUuid) {
      //no way to retrieve as we don't do key increments
      return;
    } else {
      let idx = _.findIndex(state.client.courses, function(o) {
        return o.uuid == data.courseUuid;
      });
      if (idx != -1) {
        state.client.courses[idx].selectedSectionUuid = data.sectionUuid;
      } else {
        state.client.courses.push({
          uuid: data.courseUuid,
          selectedSectionUuid: data.sectionUuid,
          sections: [],
        });
      }
      localStorage.setItem(app_id, JSON.stringify(state.client));
    }
  },
  update_password_modal_shown(state, data) {
    state.client.auth.password_modal_shown = data;
    localStorage.setItem(app_id, JSON.stringify(state.client));
  },
  tabs(state, data = []) {
    state.client.tabs = data;
    localStorage.setItem(app_id, JSON.stringify(state.client));
  },
  remove_tab(state) {
    let uuid = state.session.uuid;
    let idx = state.tabs.indexOf(uuid);
    if (idx != -1) {
      state.client.tabs.splice(idx, 1);
    }
    localStorage.setItem(app_id, JSON.stringify(state.client));
  },
  set_session_uuid(state, uuid = "") {
    if (!state.session.uuid) {
      state.session.uuid = uuid;
      sessionStorage.setItem(app_id, JSON.stringify(state.session));
      if (!state.client.tabs.includes(uuid)) {
        state.client.tabs.push(uuid);
        localStorage.setItem(app_id, JSON.stringify(state.client));
      }
    }
  },
  courses(state, data = []) {
    state.client.courses = data;
    localStorage.setItem(app_id, JSON.stringify(state.client));
  },
};
// actions are functions that causes side effects and can involve
// asynchronous operations.
const actions = {
  logout(context) {
    let state = context.state;
    let options = state.client.options;
    context.commit("auth", {});
    context.commit("profile", {});
    context.commit("options", {});
    context.commit("tabs", []);
    localStorage.removeItem(app_id);
    Events.fire("logout-successful", options);
  },
  login({ commit }, data) {
    commit("auth", data.auth);
    commit("profile", data.profile);
    commit("options", data.options);
    //console.log(data.options)
    Events.fire("login-successful", data.options);
  },
  impersonate_login({ commit }, data) {
    commit("impersonate_auth", data.auth);
    commit("impersonate_profile", data.profile);
    commit("impersonate_status", true);
    Events.fire("login-successful", data.options);
  },
  impersonate_logout(context) {
    context.commit("impersonate_auth", {});
    context.commit("impersonate_profile", {});
    context.commit("impersonate_status", false);
    Events.fire("impersonate-logout-successful");
  },
  updateProfile({ state, commit }, data) {
    if (state.client.impersonate.impersonate) {
      commit("impersonate_profile", data.profile);
    } else {
      commit("profile", data.profile);
    }
    Events.fire("profile-update-successful", data.options);
  },
  updateSearchHistory({ state, commit }, data) {
    commit("add_search_history", data);
  },
  /*data.courseUuid data.sectionUuid data.moduleUuid*/
  addHiddenModule({ commit }, data) {
    commit("add_hidden_module", data);
  },
  /*data.courseUuid data.sectionUuid data.moduleUuid*/
  removeHiddenModule({ commit }, data) {
    commit("remove_hidden_module", data);
  },
  /*For modal change password display*/
  updatePasswordModalShown({ commit }, data) {
    commit("update_password_modal_shown", data);
  },
  removeTab({ commit }) {
    commit("remove_tab");
  },
  setSessionUuid({ commit }, uuid) {
    commit("set_session_uuid", uuid);
  },
  /*data.courseUuid data.sectionUuid*/
  setCurrentSection({ commit }, data) {
    commit("set_current_section", data);
  },
};

// getters are functions
const getters = {
  isImpersonation: (state) => {
    return state.client.impersonate.impersonate;
  },
  profile: (state) => {
    if (state.client.impersonate.impersonate) {
      return state.client.impersonate.profile;
    } else {
      return state.client.profile;
    }
  },
  originalProfile: (state) => {
    return state.client.profile;
  },
  isLoggedIn: (state) => {
    if (state.client.auth.access_token != undefined) return true;
    return false;
  },
  auth: (state) => {
    if (state.client.impersonate.impersonate) {
      return state.client.impersonate.auth;
    } else {
      return state.client.auth;
    }
  },
  client: (state) => {
    return state.client;
  },
  options: (state) => {
    return state.client.options;
  },
  search_history: (state) => {
    return state.client.search_history;
  },
  tabs: (state) => {
    return state.client.tabs;
  },
  sessionUuid: (state) => {
    return state.session.uuid;
  },
  courses: (state) => {
    return state.client.courses;
  },
};
let a = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
});
if (localStorage.getItem(app_id) != null) {
  var client = JSON.parse(localStorage.getItem(app_id));
  //console.log(client.auth);
  a.commit("profile", client.profile);
  a.commit("auth", client.auth);
  a.commit("options", client.options);
  a.commit("impersonate_profile", client.impersonate.profile);
  a.commit("impersonate_auth", client.impersonate.auth);
  a.commit("impersonate_status", client.impersonate.impersonate);
  a.commit("socket", client.socket);
  a.commit("tabs", client.tabs);
  if (!client.search_history) {
    a.commit("search_history", {});
  } else {
    a.commit("search_history", client.search_history);
  }
  if (!client.courses) {
    a.commit("courses", []);
  } else {
    a.commit("courses", client.courses);
  }
}
if (sessionStorage.getItem(app_id) != null) {
  var session = JSON.parse(sessionStorage.getItem(app_id));
  a.commit("set_session_uuid", session.uuid);
}
export const store = a;
